import { LibraryIcon } from '@repo/icons/library-icon';
import { connectHits } from 'react-instantsearch-dom';

import { Button } from '~/components/ui/button';
import { cn } from '~/lib/utils';
import { AlgoliaHospitalRecord, HitsProvided } from '~/types/algolia';

import { GooseEgg } from './goose-egg';

export const SelectHospital = connectHits<
  HitsProvided<AlgoliaHospitalRecord> & {
    selectedHospital?: AlgoliaHospitalRecord | null;
    onSelectHospital: (hospital: AlgoliaHospitalRecord | null) => void;
    variant: 'form' | 'search';
  },
  AlgoliaHospitalRecord
>(({ hits, selectedHospital, onSelectHospital, variant }) => {
  if (hits.length === 0) return <GooseEgg />;

  const isFormVariant = variant === 'form';

  return (
    <ol className='mt-8 grid grid-cols-1 gap-6 md:grid-cols-2'>
      {hits.map((hit: any) => {
        const isSelected = selectedHospital?.objectID === hit.objectID;
        const isDisabled = Boolean(selectedHospital && !isSelected);

        return (
          <li
            className={cn(
              'md:border-border rounded-lg p-3 md:border md:p-6',
              isSelected ? 'bg-secondary text-secondary-foreground' : 'text-muted-foreground bg-background',
              isDisabled && 'opacity-25',
            )}
            key={hit.objectID}
          >
            <address className='not-italic'>
              {hit.city}, {hit.state}
              <h3 className='title-sm mb-4'>{hit.name}</h3>
            </address>
            {isFormVariant && (
              <div className='mt-auto flex items-center justify-between'>
                <Button
                  className={isSelected ? '' : 'bg-blue'}
                  disabled={isDisabled}
                  onClick={() => {
                    if (selectedHospital) {
                      return onSelectHospital(isSelected ? null : hit);
                    }
                    return onSelectHospital(hit);
                  }}
                  size='sm'
                  variant={isSelected ? 'secondary' : 'default'}
                >
                  {isSelected ? 'Remove' : 'Sponsor'}
                </Button>
                <div className='font-greycliff-extrabold flex items-center text-xs'>
                  <LibraryIcon className='mr-2' height={16} use='Vr' width={24} /> {hit.needs.virtualReality}
                  <LibraryIcon className='mx-2' height={16} use='Gaming' width={23} /> {hit.needs.nintendoSwitch}
                  <LibraryIcon className='mx-2' height={16} use='Gown' width={18} /> {hit.needs.gowns}
                  <LibraryIcon className='mx-2' height={16} use='Play' width={24} /> {hit.needs.toys}
                </div>
              </div>
            )}
          </li>
        );
      })}
    </ol>
  );
});
